export default __webpack_public_path__ + "static/media/badge-earlyadopter.2c378d21.png";